'use strict';

var Utils = require('./utils.js');
var OSS_DOMAINS = [
  '//3vj-fe.3vjia.com',
  '//3vj-community.3vjia.com',
  '//3vj-render.3vjia.com',
  '//3vj-scheme.3vjia.com',
  '//3vj-platform.3vjia.com',
];

/**
 * 判断当前浏览器是否支持图片webp格式
 * Created by kezhi on 2020/04/06.
 */
Utils.isSupportWebp = function() {
  return !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
};

/**
 * 阿里云图片转webp格式显示
 * Created by kezhi on 2020/04/06.
 * @param {string} url 图片url
 * @param {boolean} ignoreDomain 是否忽略域名校验
 * @return {string} 转换后的图片url
 */
Utils.webpFormat = function(url, ignoreDomain) {
  var suffix = '/format,webp';
  if (!Utils.isSupportWebp() || (!ignoreDomain && !isOssImg(url)) || url.indexOf(suffix) > -1) {
    return url;
  }
  return url + getOssParamPrefix(url) + suffix;
}

/**
 * 阿里云图片缩放
 * Created by kezhi on 2020/04/06.
 * @param {string} url 图片url
 * @param w {number} 截取宽度
 * @param h {number} 截取高度
 * @param type {string} 截取方式，常用参数(fiexd:强制宽高缩略，fill:固定宽高，自动裁剪，lfit:等比缩放,长边优先，mfit:等比缩放,短边优先), 默认：lfit
 * @param {boolean} ignoreDomain 是否忽略域名校验
 * @return {string} 转换后的图片url
 */
Utils.resizeFormat = function(url, w, h, type, ignoreDomain) {
  if ((!ignoreDomain && !isOssImg(url)) || url.indexOf('/resize,') > -1) {
    return url;
  }
  var _type = type ? ',m_' + type : '';
  var _w = w ? ',w_' + w : '';
  var _h = h ? ',h_' + h : '';
  var params = (w || h) ? '/resize' + _type + _w + _h : '';
  return url + (params ? getOssParamPrefix(url) + params : '');
}

/**
 * 平台图片格式转换
 * Created by kezhi on 2020/04/06.
 * @param {string} url 图片url（相对路径地址）
 * @param {number} w 截取宽度
 * @param {number} h 截取高度
 * @param {string} type 截取方式，常用参数(fiexd:强制宽高缩略，fill:固定宽高，自动裁剪，lfit:等比缩放,长边优先，mfit:等比缩放,短边优先), 默认：lfit
 * @param {boolean} noWebp 无须转成webp
 * @return {string} 转换后的图片url
 */
Utils.platImgFormat = function(url, w, h, type, noWebp) {
  if (!url || url.indexOf('http') === 0 || url.indexOf('//') === 0) {
    return url;
  }
  var imgPath = url.toLowerCase();
  if (imgPath.indexOf('customescheme') > -1) {
    url = 'https://3vj-community.3vjia.com' + url;
  } else if (imgPath.indexOf("render") > -1) {
    url = 'https://3vj-render.3vjia.com' + url;
  } else if (imgPath.indexOf("scheme") > -1) {
    url = 'https://3vj-scheme.3vjia.com' + url;
  }
  url = Utils.resizeFormat(url, w, h, type);
  if (!noWebp) {
    url = Utils.webpFormat(url);
  }
  return url;
}

/**
 * 判断是否是阿里云图片
 * Created by kezhi on 2020/04/06.
 * @param {string} url 图片url
 * @return {boolean}
 */
function isOssImg(url) {
  return typeof url === 'string' && OSS_DOMAINS.some(function(v) { return url.indexOf(v) > -1 })
}

/**
 * 阿里云图片参数前缀
 * Created by kezhi on 2020/04/06.
 * @param {string} url 图片url
 * @return {string} 返回参数前缀
 */
function getOssParamPrefix(url) {
  var isOssParams = url.indexOf('x-oss-process=image') > -1;
  var char = url.indexOf('?') > -1 ? '&' : '?';
  return isOssParams ? '' : char + 'x-oss-process=image';
}

module.exports = Utils;
